import React, { Component } from 'react';
import { InputGroup } from '@blueprintjs/core';
import FormField from './FormField.js'
import './FormField.css'


export default class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intent: 'none',
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    let value = event.target.value;
    this.props.onChange(value);
  }

  render() {
    const { lang } = this.props;
    let _lang = lang ? lang : 'fa';
    let value = this.props.value ? this.props.value : '';
    return (
      <FormField label={this.props.label} labelWidth={this.props.labelWidth} style={{...this.props.style, direction: _lang==='fa'?'rtl':'ltr'}} 
        vertical={this.props.vertical} required={this.props.required}>
        <InputGroup fill type="text" value={value} onBlur={this.props.onBlur} disabled={this.props.disabled ? this.props.disabled : false} 
          onChange={this.onChange} intent={this.props.intent} style={{direction: _lang==='fa'?'rtl':'ltr'}}
        />
      </FormField>
    )
  }
}
